export default __webpack_public_path__ + "static/media/login-image-mobile.3cdf0934.jpg";